/**
 * @generated SignedSource<<6e3f0211de24164aa51afd3a4d7df193>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateCategoryInput = {
  name: string;
};
export type CategoryListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateCategoryInput;
};
export type CategoryListAddMutation$data = {
  readonly createCategory: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"CategoryListRow_category">;
    };
  };
};
export type CategoryListAddMutation = {
  response: CategoryListAddMutation$data;
  variables: CategoryListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CategoryNode",
        "kind": "LinkedField",
        "name": "createCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CategoryListRow_category"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CategoryListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CategoryNode",
        "kind": "LinkedField",
        "name": "createCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "CategoryEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "614a2a924d79f814e8b9f9d7e0eb4386",
    "id": null,
    "metadata": {},
    "name": "CategoryListAddMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryListAddMutation(\n  $input: CreateCategoryInput!\n) {\n  createCategory(input: $input) {\n    node {\n      ...CategoryListRow_category\n      id\n    }\n  }\n}\n\nfragment CategoryListRow_category on Category {\n  id\n  name\n  ...SortableEntityTableRow_entity\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "1aa48eb304024b1952e29c4bd0d249a4";

export default node;
